import React from 'react'
import { Button, Divider, Drawer, Flex, Tag } from 'antd'
import CarCard from '../../../../components/Cards/CarCard'
import { ICarInterested } from '../../../../api/customer/customerApi'
import URL_CAR, { URL_CAR_CATEGORY } from '../../../../env'

interface Props {
  show: boolean
  inforCarInterested?: ICarInterested
  onClose: () => void
}

const FavoriteCarDrawer: React.FC<Props> = ({
  show, inforCarInterested,
  onClose
}) => {

  return (
    <Drawer
      open={show}
      title='Thông tin xe quan tâm'
      className='rs-drawer'
      closeIcon={false}
      footer={
        <Button
          block
          onClick={onClose}
        >Đóng</Button>
      }
      onClose={onClose}
    >
      <Flex vertical className='gap-18px'>
        <CarCard
          name={inforCarInterested?.categoryCar.title}
          avatar={URL_CAR + inforCarInterested?.car.image}
        />
        <Flex justify='space-between' className='gap-8px'>
          <span className="neutral-gray-700">Thương hiệu</span>
          <Flex align='center' justify='flex-end' className='gap-12px'>
            <span className="neutral-gray-400 text-end">{inforCarInterested?.categoryCar.title}</span>
            <img src={URL_CAR_CATEGORY + inforCarInterested?.categoryCar.image} alt='' className='h-24px w-24px' style={{ objectFit: 'contain' }} />
          </Flex>
        </Flex>
        <Flex justify='space-between' className='gap-8px'>
          <span className="neutral-gray-700">Phân khúc</span>
          <span className="neutral-gray-400 text-end">{inforCarInterested?.typeVehicle.title}</span>
        </Flex>
        <Flex justify='space-between' className='gap-8px'>
          <span className="neutral-gray-700">Dòng xe</span>
          <span className="neutral-gray-400 text-end">{inforCarInterested?.carLine.title}</span>
        </Flex>
        <Flex justify='space-between' className='gap-8px'>
          <span className="neutral-gray-700">Màu xe</span>
          <span className="neutral-gray-400 text-end"> Xanh Đen</span>
        </Flex>
        <Flex justify='space-between' className='gap-8px'>
          <span className="neutral-gray-700">Năm sản xuất</span>
          <span className="neutral-gray-400 text-end">{inforCarInterested?.yearManufacture}</span>
        </Flex>
      </Flex>
    </Drawer>
  )
}

export default FavoriteCarDrawer
